var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_c('v-select', {
    attrs: {
      "items": _vm.genders,
      "outlined": "",
      "attach": ""
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.gender.value,
      callback: function ($$v) {
        _vm.$set(_vm.form.gender, "value", $$v);
      },
      expression: "form.gender.value"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "성별무관",
      "dense": "",
      "inset": "",
      "hide-details": ""
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.gender.isIrrelevant,
      callback: function ($$v) {
        _vm.$set(_vm.form.gender, "isIrrelevant", $$v);
      },
      expression: "form.gender.isIrrelevant"
    }
  })], 1), _c('v-col', {
    staticClass: "pa-0 pb-12",
    attrs: {
      "cols": "12"
    }
  }, [_c('discrimination-dialog-sex', {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "small": "",
            "text": "",
            "color": "primary"
          }
        }, 'v-btn', attrs, false), on), [_vm._v(" ※ 성차별금지 남녀고용평등에 관한 법률 ")])];
      }
    }])
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }